// Espanhol
export const espanhol = {
  start: "Comenzar",
  configurations: "Configuraciones",
  ramdom: "Modo de Juego Aleatorio",
  vibration: "Vibración :",
  startgame: "Vamos a comenzar",
  save: "Guardar",
  delete: "Borrar",
  update: "Actualizar",
  lets: "Juguemos",
  permanentbuy: "Compra Permanente",
  signature: "Subscripción Mensual",
  small: "Aquí puedes utilizar tu nombre verdadero... o un sobrenombre :)",
  text1: "Obtenga acceso Premium y assegure todas las actualizaciones",
  text2:
    "Subscribiéndose puedes aceder a la versión Premium siempre que quieras",
  gender: "Género",
  male: "Masculino  ",
  female: "Femenino",
  ambos: "Ambos",
  fechar: "Cerrar",
  sexualorientation: "Orientación sexual",
  heterosexual: "Heterosexual",
  homosexual: "Homosexual",
  bisexual: "Bisexual",
  chooseavatar: "Elige tu avatar",
  Participants: "Participantes",
  participant: "Registro de Participante",
  name: "Nombre",
  choosecategory: "Elige las categorías",
  categories: "Categorías",
  light: "Leve",
  preliminary: "Preliminares",
  oral: "Oral",
  anal: "Anal",
  hot: "Caliente",
  time: "Cronometrar",
  extreme: "Extremo",
  vd: "Verdad",
  dare: "Desafíos",
  truth: "Verdad",
  createMyChallenges: "Mis desafíos",
  chosen: "Seleccionados",
  text3: "¡Deja fuir el amor en ti!",
  text4: "Preparese para vivir intensamente",
  close: "Cerrar",
  sele: "Seleccione una opción",
  dev: "Desarrollado por Dev12BR",
  game: "Partido",
  get: "Compra - $ 6,49",
  sign: "Para Firmar - $ 1,09",
  next: "PRÓXIMO",
  config1: "¿ Por qué debo comprar la versión Premium ?",
  config2: "3 Categorías exclusivas y más de 800 nuevos desafíos",
  config3: "Sin anuncios",
  config4: "Escoja avatares para incrementar",
  config5: "Cree sus propios desafíos",
  config6: "Apoyas el desarrollo del juego",
  config7: "¿Por qué el juego tiene costo?",
  config8:
    "¡Para desarrollar el juego se necesita de tiempo! :) De esta forma apoyas el juego, nos ayuda a siempre estar mejorando y actualizando el juego.",
  config9: "Crea y edita tus propios desafíos",
  age: `Este juego es solo para adultos, por lo que debes tener al menos 18 años.

    Este juego es apto para parejas, por lo que debes jugar con al menos un compañero.
    
    No es una aplicación de citas, sino una forma de jugar con tu pareja.`,
  assessment:
    "Califica agregando un comentario sobre la aplicación. Sus comentarios son muy importantes para nosotros para mantener el juego de la mejor manera posible.",
  agree: "Si, soy mayor de 18 años",
  noAgree: "Cierra la aplicación",
  apoio1: "Apoye el desarrollo suscribiéndose a la versión Premium :)",
  apoio2: "No olvide calificar la aplicación en Apple Store S2",
  apoio3:
    "Obtenga acceso a todas las funciones exclusivas en la versión Premium",
  apoio4: "Deshazte de este banner - Compra la versión Premium",
  version: "Premium version",
  version1: "Premium version",
  alert1: "Registrar usuarios para jugar",
  alert2: "Registre al menos un usuario más para jugar",
  alert3: "Seleccione al menos una categoría",
  alert4: `🔥 Existen participantes sin parejas. Tenga por lo menos dos participantes para cada género sexual. 🔞. 
        
Ej: Dos heterosexuales, o 2 homosexuales.`,
  tituloAlert1: "⚠️ El juego está a punto de comenzar 😜",
  tituloAlert2:
    "⚠️ Lástima 😬, no tienes internet 📶. Conéctese a Internet en su dispositivo y compre la suscripción o plan definitivo. Y sé feliz😘.",
  parser: "sin socios",
  premiumImages: "Conviértase en Premium y acceda a más avatares",
  duvidas: "Dudas o sugerencias - desafíos picantes",
  description: "Hola, mi pregunta o sugerencia es:",
  texto99:
    "Si tiene algún problema, duda o sugerencia, envíenos un correo electrónico haciendo clic en este botón a continuación. ¡Esperamos poder hablar contigo!",
  send: "Enviar",
  contact: "Contacto",
  botaoApple: "Restaurar las compras",
  alertCompra: "Tu compra se está restaurando",
  NotPurchase: "No tienes compras.",
  notPurchase2:
    "Este enlace es solo para usuarios que compraron compras anteriores y desean restaurar a un nuevo dispositivo.",
  termOfPotitic: "Términos de uso y política de privacidad",
  alertDeuErrado: "Algo salió mal :(",
  alertDeuErrado2: "Complete toda la información",
  alertNome: "Complete el campo: Nombre",
  options: "Opciones",
  optionsTitle: "Opciones",
  gradualGame: "Juego gradual",
  textoCaixa:
    "Al activar esta selección, los desafíos serán graduales, es decir, del más ligero al más extremo según tu elección.",
  comoJogar: "Como jugar ? 🤔",
  avalie: "Dejar una opinión",
  novaCategoria: "Mis categorías",
  alterLanguage: "¿Cambiar el idioma?",
  textLanguage: "Al seleccionar un nuevo idioma, la aplicación se reiniciará.",
  textLanguage1: "Cambiar el idioma",
  cancel: "Anular",
  languages: "Idiomas",
  // email: "Correo electrónico ✉️",
  deletCat: "Borrar categoria",
  textDeletCat:
    "Al eliminar esta categoría, los desafíos presentes en esta categoría serán eliminados. Después de esta acción, ya no se puede deshacer.",
  deletDes: "Eliminar el desafío",
  textDeletDes:
    "Una vez eliminado el desafío, esta acción ya no se puede deshacer.",
  desafio: "Registrar nuevo desafío",
  desafiotexto: "Desafío",
  textoeditDesafio: "¿Quien puede hacer esto?",
  textEmquem: "En quien ?",
  nome: "Nombre",
  inicio: "Comenzar el juego",
  inicio2:
    "Cuando presione este botón, se le llevará a la pantalla de registro de jugador. 👥.",
  inicio3: "El juego está por comenzar 🎲",
  inicio4: "Próximo",
  inicio5: "Ajustes y Configuración",
  inicio6: `Ajustes como: 
  
- Desafíos en el modo progresivo.
- Cambiar idioma 
- Crear desafíos 
- Auxiliar 
- Y mucho más.`,
  inicio7: "Final",
  inicio8: `Sea Premium y tenga acceso a:

- Más de 450 nuevos desafíos desbloqueados 😎

- Personajes exclusivos 🦸‍♀️ 🧑‍🚒

- Crea tus propios desafíos. 📝

- Mantenga el juego actualizado ✅

- apoyar el desarrollo 🤝

- Y mucho más 😍`,
  inicio9: "Ayudar",
  inicio10: "Te damos la bienvenida al juego Spicy Challenges 🌶",
  inicio11:
    "Vea lo fácil que es jugar y navegar por los menús en menos de 30 segundos 😎.",
  inicio12: "Ver el tutorial 👍🏼",
  inicio13: "No quiero 👎🏼",
  inicio14: `Para iniciar el juego, es necesario agregar al menos (2) dos jugadores 😀
  
Pulsando el botón que se muestra arriba 👆

Cada vez que quieras agregar un nuevo usuario, presiona este mismo botón😘
  `,
  cadastrarCategory: "Agregar nueva categoría",
  inicio15: "Creando una nueva categoría",
  inicio16:
    "Paso 1: Presione el botón con el signo + que se encuentra en la parte inferior de esta pantalla. Luego de presionar, aparecerá una Ventana para ingresar a su nueva categoría.",
  inicio17: "Paso 2: Ingrese su nueva categoría y haga clic en guardar",
  inicio18:
    "Paso 3: Para editar, eliminar o AGREGAR DESAFÍOS dentro de la categoría, presione con el dedo sobre ella (Botón con su categoría).",
  inicio19:
    "Paso 4: En la siguiente pantalla, presionando el botón indicado con la flecha ⬆️, se abrirá una ventana para editar tu nueva categoría.",
  inicio20:
    "Paso 5: En la siguiente pantalla, presionando el botón indicado con la flecha ⬆️, eliminarás la categoría.",
  inicio21:
    "Paso 1: haga clic en el botón a continuación para agregar un nuevo desafío a esta categoría",
  inicio22: "Creando un nuevo desafío",
  inicio23:
    "Paso 2: Haga clic en cada elemento encerrado en un círculo para conocer en detalle cada campo de registro",
  inicio24: "Texto de desafío",
  inicio25: `Escribe el desafío a tu gusto, y para que se muestre el nombre del jugador en el desafío, solo presiona el botón rojo a continuación.. 
    
Se agregarán los siguientes caracteres. {nome}. 

** NO CAMBIES ESTOS CARACTERES ** Para que el nombre del jugador se muestre correctamente, debe ser como ejemplo a continuación ⬇️⬇️⬇️⬇️

Desafío: besar el cuello de {nome}`,
  inicio26: "¿Quién puede hacer y quién puede recibir?",
  inicio27: `Seleccione "Ambos" si el desafío puede ser realizado y recibido por participantes de "ambos" géneros..
  
Si el desafío está dirigido a un género, simplemente selecciona el deseado.
`,
  inicio28: "Agregando tiempo al desafío",
  inicio29:
    'En caso de que su desafío tenga un tiempo, simplemente arrastre el "rango" a continuación y el valor se mostrará arriba. Después de que expire el temporizador en el desafío, se reproducirá un sonido que anuncia que el desafío ha terminado.',
  aviso12: `Aqui apenas a categoria é criada!
    
Para agregar los desafíos solo presione el botón de su categoría que acaba de crear ⬆️⬆️⬆️⬆️`,
  voltar: "regressar",
  semDe: "Jugador sin desafíos",
  semDe2: `Registra al menos un desafío para este jugador 😬.
  
  Será redirigido a la pantalla de inicio de sesión.`,
  term: "Intimidad",
  Potitic: "Términos de uso",
  adquirited: "Adquirido",
  config10: "Categorías exclusivas",
  config11: "+ 800 nuevos desafíos",
  signatureano: "Suscripción anual",
  camera: "Fotografía",
  galery: "Galería",
  avatar: "Avatar",
  image: "Imagen",
  seletion: " Seleccionado",
  editCategory: "Editar la categoría",
  frase1: "¿Estás disfrutando de los desafíos?",
  frase2: "¿Qué tal probar los Desafíos Premium ?",
  //err texto
  errTexto:
    "Si ha encontrado un error de traducción, por favor corrija la frase en el campo de abajo:",
  errTitulo: "¿Notaste algo incorrecto?",
  errCorrect: "¿Cómo sería en español?",
  thisLanguageIsCorrect: "¿El desafío en ESPAÑOL es correcto?",
  yes: "Sí",
  no: "No",

  errSend: "Enviar sugerencia",

  share: "Compartir",
  fraseShare: `¡Qué aplicación tan buena! Sólo lo comparto porque sé que a ti también te va a gustar 🫣
Descárgalo y luego me dices si no es demasiado bueno lol...😉
  
  
Enlace de descarga: https://desafiospicantesapp.page.link/share-app`,
  bandeira: "🇪🇸",

  morePlayer: "¿Jugar con más jugadores?",
  players: "Jugadores",
  carregar: "Cargar imagen",
  takePhoto: "Hacer una foto o seleccionar una imagen",
  useAvatar: "O utilizar avatares",

  hetero: "Hetero",
  gay: "Gay",
  lesbico: "Lesbianas",

  nomeHomem1: "Nombre del hombre",
  nomeHomem2: "Nombre del hombre",
  nomeMulher1: "Nombre de la mujer",
  nomeMulher2: "Nombre de la mujer",
  messageErr: "Añadir los jugadores 🙌",
  descricaoErr: "Introduce los nombres de los participantes ✍️",
  why: "Dinos por qué...",
  later: "Evaluar más tarde",
  txtCard1: "Tu turno 🔥",
  txtCard2: "Hazlo realidad 😘",
  txtCard3: "¡Vamos! 😜",
  txtCard4: "Siguiente desafío 😈",
  txtCard5: "¡Uno más! 👄",

  tituloBloco1Novo: "Explore la intimidad sexual con su pareja",
  subtitulo1Novo:
    "¡Más de 1 millón de parejas ya han transformado su relación!",
  texto1Novo:
    "Descubre una nueva forma de conectar con tu pareja y accede a los mejores juegos diseñados para fortalecer vuestra relación y disfrutar más del amor.",

  tituloBloco2Novo:
    "Desbloquea juegos exclusivos y categorías personalizadas para vivir momentos únicos con tu pareja.",
  texto2Novo1: "Disfruta de más de 1500 desafíos",
  texto2Novo2: "Crea tus propios retos",
  texto2Novo3: "Categorías exclusivas",
  texto2Novo4: "Sin anuncios",
  texto2Novo5: "Avatares exclusivos",
  texto2Novo6: "Nuevos retos cada día",
  texto2Novo7: "Juegos actualizados regularmente.",
  tituloBloco3Novo: "Calificación más alta en la categoría",
  tituloBloco4Novo: "Beneficios para tu relación:",
  texto4Novo1: "Intimidad",
  texto4Novo2: "Deseo",
  texto4Novo3: "Levedad",
  texto4Novo4: "Atracción",
  texto4Novo5: "Conexión",
  texto4Novo6: "Placer",

  tituloBloco5Novo: "Lo que dicen las parejas",
  texto5depoimentoTitulo1: "Blade Moody",
  texto5depoimento1:
    "Creo que esta es la mejor aplicación que he encontrado en el móvil hasta ahora, erótica e interesante. Todas las demás aplicaciones que he visto no se comparan, así que consigue un trabajo y cómprala. No te quejes porque estás en bancarrota. Te estás perdiendo cosas realmente buenas aquí, y $10.00 para tener toda la aplicación. Ofrece mejores experiencias que los juegos que encuentras en las tiendas de placer locales.",

  texto5depoimentoTitulo2: "Joon Rxs",
  texto5depoimento2:
    "¡Esta aplicación es increíble! Tenía dudas sobre si debía descargarla o no, pero sin duda fue la mejor sensación que hemos tenido en los últimos tiempos. Qué bueno es saber que todavía podemos hacer muchas cosas juntos. 🤭 Probamos la versión de pago y realmente vale la pena, no habíamos llegado a ese nivel de placer aún.",

  texto5depoimentoTitulo3: "Monique SantosRader",
  texto5depoimento3:
    "¡Si quieres darle más sabor a la relación, esta aplicación es perfecta! Ya había probado otras, pero ninguna nos agradó tanto como esta. Nuestros juegos preliminares fueron mucho más calientes y placenteros (¡ahora imagina el resto!). Realmente vale la pena comprar la versión de pago (si quieres sentir un placer más intenso), pero la versión gratuita también sorprende.",

  texto5depoimentoTitulo4: "Anne Owens",
  texto5depoimento4:
    "¡Excelente! Muy buena de verdad... Nos pusimos muy excitados durante el juego, lo que hizo que el sexo fuera mucho más apasionante, ¡fue placer por todas partes! Ya estamos ansiosos por jugar de nuevo 💦🔥. También recomendamos la versión de pago si pueden soportar tanta excitación 🤤.",
  tituloBloco6Novo:
    "Haz como cientos de parejas de todo el mundo y dale un toque picante a tu relación. Descubre más de 800 nuevos desafíos.",
  texto6Select: "Elige la versión:",
  texto6Premium: "Premium",
  texto6Assinatura: "Suscripción",
  texto6Mensal: "Mmensual",
  texto6Anual: "Anual",
  texto6Vitalicia: "Licencia vitalicia",
  bePremium: "Mejora tu relación ahora",
  buyNew: "Comenzar Ahora",
  attention: "Atención.",
  changeGender: "Has cambiado de orientación sexual.",

  tituloAvaliacao: "¿Disfrutando del juego?",
  textoAvaliacao: "¡Valóralo y ayúdanos a seguir mejorando!",
  agoraNão: "Ahora no",
  enviarAvaliacao: "Enviar",

  nomeJogo1: "Desafíos Sensuales",
  nomeJogo2: "¡Verdad o Reto!",
  nomeJogo3: "Nivel de Picardía",
  nomeJogo4: "Ruleta Traviesa",
  nomeJogo5: "Cita del Día",
  naughtyQuiz: "Quizz travieso",

  playAlone: "Jugar en Solitario",
  estaSozinho: "¿Jugando solo?",
  selectPlayer: "Seleccionar Jugador",

  skip: "Saltar",
  responder: "Enviar",
  respondaAqui: "Responde aquí",
  config4: "Elige avatares para personalizar",

  tituloSelect1: "¿Juegas solo?",
  tituloSelect2: "¡Responde a preguntas atrevidas!",

  subTituloSelect1: "¡Te echamos una mano!",
  subTituloSelect2: "Descubre qué tan travieso eres",
  txtJogador1:
    "Selecciona tu jugador y explora placeres guiados diseñados solo para ti.",
  txtJogador2: "El jugador seleccionado responderá a las preguntas",
  tituloCena: "¿QUÉ ÍTEMS TE GUSTARÍA USAR?",
  subTituloCena:
    "¿No tienes alguno? Toca 'Obtener' y adquiérelo en la tienda asociada.",
  play: "Jugar",

  titleUserWarning: "Elegir un usuario",
  txtUserWarning: "Selecciona un usuario para responder las pregunta",

  shareNivelDeSafadeza:
    "Oye, mira mi nivel de picardía 😈 Experimenta intensos momentos de placer. Hazlo tú también 💋 Descarga la aplicación ahora y prepárate para disfrutar de desafíos calientes 🔥 con tu pareja!: ➡️ https://desafiospicantesapp.page.link/sharelevelhot",

  shareDica:
    "¡Transforma tu vida amorosa ahora mismo! Descarga la aplicación y descubre el secreto para una relación picante: ➡️ https://desafiospicantesapp.page.link/tipoftheday",

  resultadoQuiz1:
    "Eres una persona recatada, no disfrutas mucho de la picardía, prefieres algo más romántico.",
  resultadoQuiz2:
    "Eres demasiado romántico para abusar de la picardía y disfrutas más del ambiente a la luz de las velas.",
  resultadoQuiz3:
    "Eres una persona bastante reservada y crees en mantener las cosas discretas y privadas en la vida íntima.",
  resultadoQuiz4:
    "Esto no significa que no seas travieso/a a veces, pero prefieres guardar todo ese fuego para compartirlo con alguien muy especial.",
  resultadoQuiz5:
    "Tu calor está en segundo plano, pero eso no cambia el hecho de que hay calor.",
  resultadoQuiz6:
    "Te gusta explorar nuevas experiencias, pero siempre con respeto y consentimiento.",
  resultadoQuiz7:
    "Disfrutas de una cita caliente, llena de besos y mucha pasión. Sin embargo, también hay un lado tuyo que disfruta viendo una película mientras sostiene la mano de tu crush o cenando a la luz de las velas.",
  resultadoQuiz8:
    "Estás dispuesto a probar cosas nuevas y emocionantes, pero siempre con responsabilidad.",
  resultadoQuiz9:
    "Eres una persona atrevida y te gusta darle sabor a las cosas en la vida íntima de vez en cuando.",
  resultadoQuiz10:
    "Disfrutas de todos los placeres de la vida y no tienes límites cuando se trata de sexo.",
  resultadoQuiz11:
    'Contigo no hay tiempo malo, ¡siempre es hora de una aventura rápida! ¿Películas románticas? Solo si es "50 Sombras de Grey".',
  resultadoQuiz12:
    "Para ti, la intimidad es una aventura constante y no tienes miedo de correr riesgos.",
  mes: "Mes",
  desafiosRestantesDois: "Te quedan 2 desafíos Premium.",
  nenhumDesafioRestante: "¡No quedan desafíos Premium!",
  tornePremiumAviso1:
    "Hazte Premium ahora y disfruta de 1000 desafíos exclusivos.",
  tornePremiumAviso2:
    "Disfruta de desafíos ilimitados, contenido exclusivo y diversión sin interrupciones.",
  conteudoPremium: "Has seleccionado contenido Premium.",
  aproveite4desafios:
    "Disfruta de 4 desafíos premium para experimentar un placer exclusivo.",
  calculando: "Calculando Resultados...",
  nivelRomantismo: "Tu nivel de romanticismo es...",
  finalizar: "Finalizar",
  erroQuizTitulo: "Introduce tu respuesta",
  erroQuizFrase: "¡Para avanzar, introduce tu respuesta!",
  new: "NUEVO APP",

  //resposta quiz safadeza
  resQuiz1: "Cautivador",
  resQuiz2: "Apasionado",
  resQuiz3: "Encantador",
  resQuiz4: "Muy travieso",

  texto6Semanal: "Semanal",
  weekly: "Firma Semanal",

  tempSemanal: "Cobrado semanalmente",
  tempMensal: "Cobrado mensalmente",
  tempAnual: "Cobrado anualmente",
  tempSempre: "Pago único",
  canceleAny: "Cancela en cualquier momento",

  //Tela do safadrometro
  Low: "Bajo",
  Medium: "Medio",
  High: "Alto",

  lifeTime: "Acceso de por vida",
  notNow: "No ahora, gracias",
  match: "HACER MATCH CON A.I.",

  dateTitle: "¿Quieres conocer nuestra nueva aplicación?",

  dateBody:
    "¿Quieres chatear con bots traviesos 😈 y practicar tu coqueteo? ¡Te va a divertir!🔥",
  goToDate: "¡Prueba Date.AI ahora!",

  goodForU: "¿FUE BUENO PARA TI?",
  rateOurPerformance: "Evalúe nuestro rendimiento hasta aquí",
  veryGood: "Muy Bueno",
  veryBad: "Muy Malo",
  feedbackChallenge:
    "¿Qué te haría compartir la aplicación Hot Challenges con otras parejas y por qué?",
  type: "Escriba su respuesta aquí...",
  survey: "Encuesta de satisfacción.",
  shareIfConfortable:
    "Siéntete libre de compartir con amigos si te sientes cómodo :)",

  howToPlay: "Cómo Jugar",
  howToPlayHotChallenge:
    "¡Prepárate para subir la temperatura! Saca una carta de desafío y sorprende a tu pareja con una acción ardiente.",

  preGameTip1: "Desata tus deseos y crea momentos inolvidables con tu pareja.",
  preGameTip2: "Enciende tus pasiones y crea momentos inolvidables juntos.",
  preGameTip3: "Explora tus deseos más salvajes y crea recuerdos inolvidables.",
  preGameTip4: "Libera tus fantasías y disfruta de momentos de puro placer.",
  selecionajoagador: "Hora de jugar",
  dica: "Consejo",

  howToPlayNaughty:
    "Elige tus juguetes y objetos favoritos. Gira la ruleta y deja que el destino decida tu próximo desafío travieso.",
  howToPlayTruthOrDare:
    "Elige tu destino: comparte una verdad o acepta un desafío atrevido. ¡Que empiece la diversión!",
  howToKama1: "Descubre Posiciones de Placer – ¡365 Días de Pasión!",
  howToKama2:
    "Elige una carta al azar, prueba la posición y explora nuevas alturas de placer juntos.",
  kamaExplain:
    "Desbloquea una nueva posición cada día y construye tu colección definitiva de pasión: tu viaje de 365 días de placer inolvidable comienza aquí.",
  howToDo: "Cómo hacer",
  pergunta: "Pregunta",

  restart: "Reiniciar",
  dialogText1HotChallenges:
    "Has completado todos los desafíos disponibles con las categorías seleccionadas.",
  dialogText2HotChallenges:
    "¡Selecciona más categorías o reinicia el juego con los desafíos actuales!",
  noChallenges: "¡Sin desafíos!",

  objects: "Objetos",
  dialogText1NaughtyGames:
    "Has completado todos los desafíos disponibles con los objetos seleccionados.",
  dialogText2NaughtyGames:
    "¡Selecciona más objetos o reinicia el juego con los desafíos actuales!",
  unlockPremium: "Desbloquear Premium",
  noCategory: "Por favor, elige al menos una categoría para comenzar.",
  thanksForFeedback: "¡Gracias por ayudarnos a mejorar la experiencia!",
  categoryKamasutra: "¡Elige tu pasión y juega!",
  tap: "¡Toca para revelar tu posición!",
  step: "Guía Paso a Paso",
  shareQuizButton: "¡Comparte tu nivel de picardía!",
  tryAgain: "Inténtalo de nuevo",
  unlockAllFun: "Desbloquea toda la diversión",
  limitedOffer: "¡Oferta especial por tiempo limitado!",
  fill: "Escribe tu nombre y el de tu pareja.",
  kamaNotificationTitle: "🔥 ¡Tu nueva carta está desbloqueada!",
  kamaNotificationBody:
    "Tu posición del día {variavel} está lista. ¿Qué tal probar algo nuevo hoy? 💋",

  titleNewGame: "¡Prepárate para el Roleplay!",
  phraseNewGame:
    "En la próxima actualización, llegará un nuevo juego para explorar tus fantasías más creativas. Elige personajes, crea historias y lleva la diversión a un nuevo nivel con tu pareja. 🔥",
  awaitNewGame: "¡Espera y prepárate para vivir momentos únicos!",
  selectObjects:
    "Selecciona dos o más elementos para personalizar tu juego. Explora al máximo.",

  soon: "Muy Pronto",
  wantToBeNotify: "Quiero ser notificado.",
  ok: "OK",
  vezDe: "GIRO",

  categoryLabel: "Categoría",
  descriptionLabel: "Descripción",

  loginConnect: "Iniciar sesión",
  loginNoAccount: "¿No tienes una cuenta?",
  loginCreateNow: "Crea una ahora",
  loginOrConnect: "o conéctate con",

  email: "Correo electrónico",
  password: "Contraseña",
  loginRegister: "Registrarse",
  loginAlreadyHas: "¿Ya tienes una cuenta?",
  enterNow: "Entra ahora",

  logout: "Cerrar sesión",
  customerPortal: "Portal del Cliente",
  installApp: "Instalar Aplicación",
  loginVideo:
    "https://desafios-picantes-bucket.dev12br.com/videos-login/espanhol.mp4",
};
